import React, { useEffect, useState } from "react";
import {Link, useParams} from 'react-router-dom';
import {MAIL_ACCOUNT_ALL_LINK} from "../../constants/constants";
import FormValidator from "../../FormValidator";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from "../../api";
import { notifyError, notifySuccess } from "../../helper";

const EditGoogleSmtpAccount = () => {
    const {emailID} = useParams('');
    const api = client();
    const [data,setData] = useState({
        server:'',
        port:'',
        username:'',
        password:''        
    });
    const [loading,setLoading] = useState(false);

    const validatorRules = {
        
        server:{
            rule1:{
                message: "Please Enter a Valid SMTP Host Name.",
                validator: (val) => !((/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/).test(val))
            },
            // rule2:{
            //     message: "Gmail domain is not allowed.",
            //     validator: (val) => !((/^(?!([a-z0-9._-]+\.)?gmail\.com$).+$/i).test(val))
            // }
        },
        port:{
            empty:"Please Enter SMTP Port Number."
        },
        username:{
            empty:"Please Enter SMTP Username."
        },
        password:{
            empty:"Please Enter SMTP Password."
        }
    }

    const prepareData = (input) => {
        setData({...data,...input});    
    }
    
    const validatorObject = new FormValidator(validatorRules);
    const [error, setError] = useState({});

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);
        //update()
    }

    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }

    const rearrangeData = (inputValues) => {
        return {
            "id": emailID,
            "smtp": {
                "server": inputValues.server,
                "port": inputValues.port,
                "username": inputValues.username,
                "password": inputValues.password
            }            
        }
    }

    const updateGoogleSmtpAccount = async() => {
        try{
            setLoading(true);
            if(emailID.length && validateAllFields(data)){
                const payload = rearrangeData(data);
                const response = await api.post("/v1/mailAccount/google-smtp/update", payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Google SMTP account updated successfully');
                    setTimeout(()=>{
                        window.location.href = MAIL_ACCOUNT_ALL_LINK;
                    },1200);
                }
            }
        } catch(error){
            setLoading(false);
            if(error.status === 400){
                notifyError("Bad Request. Unable to create Google SMTP account. Please try again.");
            }
        } finally{
            setLoading(false);
        }
    }
    useEffect(()=>{
        const getGoogleSmtpDetails = async () => {
            try{
                const payload = {id:emailID}
                const response = await api.post("/v1/mailAccount/google-smtp/get",payload);

                if(response.status === 200 || response.status === 201){
                    setData(response.data.data.credentials.smtp);                    
                }

            } catch (error) {
                console.log("error.message",error);
                if(error.status === 400){
                    notifyError("Bad Request. Unable to fetch Google SMTP connection info. Please try again");
                }
            } finally {

            }
        }
        getGoogleSmtpDetails();
    },[]);
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="mailaccounts-pages-wrap">
                <div className="top-section">
                    <h1>Update SMTP Connection for Google account</h1>
                    <div className="button-group">
                        <Link to={MAIL_ACCOUNT_ALL_LINK} className="primary-btn"><i className="bx bx-list-ul"></i> All  Mail Accounts</Link>
                    </div>
                </div>
                <div className="create-mailaccount-wrap">
                    <div className="mail-create-form">
                        <form onSubmit={(e)=>{e.preventDefault();}} encType="multipart/form-data" method="post">
                            <div className="form-content">
                                <h3>Edit SMTP connection</h3>
                                <p>This information comes from your email provider and is how we'll send your emails.</p>
                            </div>
                            <div className="form-group">
                                <div className="column-2-inner">
                                    <div className="field-wrap col-1">
                                        <label className="label-xs">Host (e.g. mail.server.com)</label>
                                        <input 
                                            type="text" 
                                            name="server" 
                                            placeholder="Host Name" 
                                            value={data?.server ? data.server:''}
                                            onChange={(e)=>{
                                                prepareData({"server": e.target.value});
                                            }} 
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            onFocus={(e) =>{
                                                fieldFocus(e)
                                            }}
                                            />
                                            {error.server && <span className="validation-error">{error.server}</span>}
                                    </div>
                                    <div className="field-wrap col-2">
                                        <label className="label-xs">Port number</label>
                                        <select
                                            name="port" 
                                            className="selectbox" 
                                            value={data?.port ? data.port:''}
                                            onChange={(e)=>{
                                                prepareData({'port':e.target.value});
                                            }}
                                            onFocus={(e)=>{
                                                fieldFocus(e);
                                            }}
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            >
                                                <option value={''}>Port</option>
                                                <option value={25}>25</option>
                                                <option value={465}>465</option>
                                                <option value={587}>587</option>
                                                <option value={2525}>2525</option>
                                        </select>
                                        {error.port && <span className="validation-error">{error.port}</span>}                                
                                    </div>
                                </div>
                            
                                <div className="field-wrap">
                                    <label className="label-xs">Username (usually your email address)</label>
                                    <input 
                                        type="text" 
                                        name="username" 
                                        placeholder="Username"
                                        value={data?.username ? data.username:''}
                                        onChange={(e)=>{
                                            prepareData({"username": e.target.value});
                                        }} 
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.username && <span className="validation-error">{error.username}</span>}
                                </div>

                                <div className="field-wrap">
                                    <label className="label-xs">Password</label>
                                    <input 
                                        type="password" 
                                        name="password" 
                                        placeholder="*****"
                                        value={data?.password ? data.password:''}
                                        onChange={(e)=>{
                                            prepareData({"password": e.target.value});
                                        }}  
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.password && <span className="validation-error">{error.password}</span>}
                                </div>
                            </div>
                            <div className="field-wrap form-btn">
                                <button 
                                className={loading ? "primary-btn button--loading":"primary-btn"} 
                                disabled={loading}
                                onClick={()=>{
                                    updateGoogleSmtpAccount()
                                }}><span className="button--text">Update</span></button>
                                <button className="back-btn" onClick={()=>{
                                    window.location.href= MAIL_ACCOUNT_ALL_LINK;
                                }}>Back</button>
                            </div>
                        </form>                        
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>);
}

export default EditGoogleSmtpAccount;